module.exports = __webpack_public_path__ + "481cab43e27a4d42feff981f8baff628.svg";